import {
    TOUR_ADMIN_ALL_TRANSACTION_LIST_START,
    TOUR_ADMIN_ALL_TRANSACTION_LIST_SUCCESS,
    TOUR_ADMIN_ALL_TRANSACTION_LIST_ERROR,
    TOUR_ADMIN_PENDING_TRANSACTION_LIST_START,
    TOUR_ADMIN_PENDING_TRANSACTION_LIST_SUCCESS,
    TOUR_ADMIN_PENDING_TRANSACTION_LIST_ERROR,
    TOUR_ADMIN_COMPLETED_TRANSACTION_LIST_START,
    TOUR_ADMIN_COMPLETED_TRANSACTION_LIST_SUCCESS,
    TOUR_ADMIN_COMPLETED_TRANSACTION_LIST_ERROR,
} from "../Constants/OperatorTourTransactionListConstant"

const initialState = {
    loading: false,
    allTransactionListData: {},
    pendingTransactionListData: {},
    completedTransactionListData: {},
};
export default function OperatorTourTransactionListReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case TOUR_ADMIN_ALL_TRANSACTION_LIST_START:
            return {
                ...state,
                allTransactionListData: {},
                loading: true,
            };
        case TOUR_ADMIN_ALL_TRANSACTION_LIST_SUCCESS:
            return {
                ...state,
                allTransactionListData: action.payload,
                loading: false,
            };
        case TOUR_ADMIN_ALL_TRANSACTION_LIST_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case TOUR_ADMIN_PENDING_TRANSACTION_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case TOUR_ADMIN_PENDING_TRANSACTION_LIST_SUCCESS:
            return {
                ...state,
                pendingTransactionListData: action.payload,
                loading: false,
            };
        case TOUR_ADMIN_PENDING_TRANSACTION_LIST_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case TOUR_ADMIN_COMPLETED_TRANSACTION_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case TOUR_ADMIN_COMPLETED_TRANSACTION_LIST_SUCCESS:
            return {
                ...state,
                completedTransactionListData: action.payload,
                loading: false,
            };
        case TOUR_ADMIN_COMPLETED_TRANSACTION_LIST_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}

